import { Paragraph } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

const StyledContainer = styled.div`
  max-width: 1080px;
  font-family: SourceSansPro;
`;

const RouteContainer = styled.section`
  width: 100%;

  nav {
    padding-top: 66px;
  }
`;

const DropdownContainer = styled.div`
  width: 464px;
`;

const StyledInputContainer = styled.div<{ fullWidth?: boolean }>`
  width: ${(props) => (props.fullWidth ? '100%' : '464px')};

  .MuiButton-contained {
    margin-top: 24px;
    margin-bottom: 32px;
  }
`;

const StyledConfigurationText = styled.p`
  font-size: 20px;
  margin-top: 17px;
  margin-bottom: 32px;
`;

const StyledComponentParagraph = styled(Paragraph)`
  margin-bottom: 16px;
`;
export {
  StyledContainer,
  RouteContainer,
  DropdownContainer,
  StyledInputContainer,
  StyledConfigurationText,
  StyledComponentParagraph,
};
